<script lang="ts">
import { h } from 'vue';
import { marked } from 'marked';
import ExpertReviewGroup from './ExpertReviewGroup.vue';

const components: Record<string, any> = {
  ExpertReviewGroup,
};

const parseComponent = (str: string) => {
  const regex = /<p>\s*::Component.([a-zA-Z0-9-_]+?)\s*<\/p>\n*/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(str))) {
    parts.push({
      type: 'text',
      value: str.substring(lastIndex, match.index),
    });
    parts.push({
      type: 'component',
      value: match[1],
    });
    lastIndex = match.index + match[0].length;
  }

  parts.push({
    type: 'text',
    value: str.substring(lastIndex),
  });

  return parts;
}

export default {
  name: 'Markdown',

  props: {
    content: {
      type: String,
      default: '',
    },

    breaks: {
      type: Boolean,
      default: false,
    },

    textClass: {
      type: String,
      default: '',
    },

    componentClass: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    marked.use({
      renderer: {
        link(token) {
          const html = marked.Renderer.prototype.link.call(this, token);
          return html.replace(/^<a /, '<a target="_blank" ');
        },
      },
      gfm: true,
      breaks: props.breaks,
    });

    const parsedContent = props.content ? marked.parse(props.content) as string : '';
    const contentArray = parseComponent(parsedContent);

    // 返回渲染函数
    return () => h('div', { class: 'markdown-container <md:max-w-full' }, contentArray.map((item) => {
      if (item.type === 'text' && item.value !== '') {
        return h('div', {
          class: ['markdown-node', 'markdown-node-text', '<md:overflow-x-auto', props.textClass],
          innerHTML: item.value,
        });
      }
      else if (item.type === 'component') {
        const component = components[item.value];

        if (component) {
          return h(component, {
            class: ['markdown-node', 'markdown-node-component', props.componentClass],
          });
        }
        else {
          return '';
        }
      }
      else {
        return '';
      }
    }));
  },
}
</script>

<style lang="scss" scoped>
.markdown-node-text {
  :deep(img) {
    max-width: 100%;
    height: auto;
  }

  :deep(table) {
    max-width: 100%;
  }
}
</style>
